<!-- Question -->
<div class="c-survey__section survey-question">
  @for (text of questionDetails.QuestionText; track text) {
    <h2 [attr.headerid]="text" class="c-survey__question is-multi-question">{{ text | translate: { maskName: surveyData?.maskName} }}</h2>
  }
</div>

<!-- Button style answer choices list -->
<div class="c-survey__section survey-choices">
  @for (answer of questionDetails.PossibleAnswers; track answer; let i = $index) {
    <span>
      @if (answer.hasOwnProperty("HeaderText")) {
        <h3 class="c-survey__question  u-text-align-left">{{answer.HeaderText | translate}}</h3>
      }
      <button type="button" [attr.answerId]="answer.AnswerId" class="c-survey__answer-multi-select" [ngClass]="selectedAnswerIndexes.includes(i) ? 'is-active' : '' " (click)="this.answerSelected(answer, i)">{{answer.AnswerText | translate}}</button>
      @if (answer.FreeText && selectedAnswerIndexes.includes(i)) {
        <span class="c-form-field  u-text-align-left">
          <label class="c-form-field__label">{{'describe' | translate}}</label>
          <div class="c-form-field__input">
            <input maxlength="100" type="text" class="c-input c-input--text" [(ngModel)]="answer.Description" (ngModelChange)="this.answerSelected(answer, -1)">
          </div>
          <div class="c-form-field__hint">
            {{ 'enter-description' | translate }}
          </div>
        </span>
      }
    </span>
  }
</div>

@if (questionDetails.hasOwnProperty("InfoText")) {
  <div>
    <h6 class="c-survey__help">{{questionDetails.InfoText | translate}}</h6>
  </div>
}
